import { IMenuItem } from '@/biz/models/Menu.model'

export function genMenuNameShow(menu: IMenuItem) {
  if (!menu.nameShow) menu.nameShow = menu.name

  if (menu.nameCustomFun) {
    const nameRes = menu.nameCustomFun()
    if (nameRes instanceof Promise) {
      nameRes.then((res: any) => (menu.nameShow = res))
    } else {
      menu.nameShow = nameRes
    }
  }
}
